import { Tooltip } from 'antd';
import { educationParallelTextRepresentation } from 'entities/education-class';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppAlertIcon } from 'shared/UI/UIKit/icons/Alert';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppModal } from 'shared/UI/UIKit/Modal';
import { AppTable } from 'shared/UI/UIKit/Table';
import type { DailyViolation, Schedule } from 'services/api';
import { modalColumnsConfig, useTableHeader } from '../model';
import styles from './styles.module.scss';

export const TableHeader = () => {
  const {
    state: {
      schedule,
      classesWithViolations,
      modalVisible,
      selectedClass,
      difficultyDistribution,
      hideDifficultyDistributionConflicts,
    },
    methods: { handleShowModal, handleCloseModal },
  } = useTableHeader();

  const classHeaderRender = (scheduleItem: Schedule) => {
    const hasViolation = classesWithViolations?.includes(scheduleItem.educationalClass.id);
    const currentClass = difficultyDistribution?.curriculumReports.find(
      (report) => report.educationalClass.id === scheduleItem.educationalClass.id,
    );

    if (hasViolation && !hideDifficultyDistributionConflicts) {
      return (
        <th key={scheduleItem.educationalClass.id} className={styles.classCol}>
          <div className={`${styles.classHeader} ${styles.classHeader_violation}`}>
            <AppFlex alignItems="center" direction="row" justifyContent="center" unit="8">
              <div>
                {`${educationParallelTextRepresentation[scheduleItem.educationalClass.parallel]}${
                  scheduleItem.educationalClass.litera
                }`}
              </div>
              <Tooltip
                title={
                  <AppFlex direction="column" justifyContent="center">
                    <div style={{ textAlign: 'center' }}>Превышение нормы нагрузки по дням</div>
                    <AppButton
                      className={styles.detailsButton}
                      onClick={() => handleShowModal(currentClass)}
                    >
                      Подробности
                    </AppButton>
                  </AppFlex>
                }
                placement="bottom"
                overlayInnerStyle={{
                  borderRadius: '6px ',
                  padding: '8px',
                  backgroundColor: 'rgba(0, 0, 0, 0.7)',
                }}
              >
                <AppAlertIcon />
              </Tooltip>
            </AppFlex>
          </div>
        </th>
      );
    }

    return (
      <th key={scheduleItem.educationalClass.id} className={styles.classCol}>
        <div className={styles.classHeader}>
          {`${educationParallelTextRepresentation[scheduleItem.educationalClass.parallel]}${
            scheduleItem.educationalClass.litera
          }`}
        </div>
      </th>
    );
  };

  const modalDifficultyDistributionContentRender = () => {
    if (modalVisible && selectedClass) {
      return (
        <AppFlex>
          <AppTable
            columns={modalColumnsConfig}
            dataSource={selectedClass.dailyViolations}
            rowKey={(record: DailyViolation) => record.dayOfWeek}
          />
        </AppFlex>
      );
    }

    return null;
  };

  return (
    <>
      <thead>
        <tr>
          <th className={styles.dayCol}></th>
          <th className={styles.lessonCol}></th>
          {schedule?.map((scheduleItem) => classHeaderRender(scheduleItem))}
        </tr>
      </thead>
      <AppModal
        visible={modalVisible}
        onCancel={handleCloseModal}
        title={`Нарушения распределения учебной нагрузки для ${
          selectedClass
            ? educationParallelTextRepresentation[selectedClass.educationalClass.parallel]
            : ''
        }${selectedClass ? selectedClass.educationalClass.litera : ''}`}
        content={modalDifficultyDistributionContentRender()}
        size="large"
        footer={
          <AppButton type="outline" onClick={handleCloseModal}>
            Закрыть
          </AppButton>
        }
      />
    </>
  );
};
